import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '@jumbo/components/PageComponents/PageLoader';

const Relation = () => {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={`${match.url}/dealer`} component={lazy(() => import('./Dealer'))} />
        <Route path={`${match.url}/customer`} component={lazy(() => import('./Customer'))} />

        <Route component={lazy(() => import('../../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default Relation;
